import React from "react";

export default function AleartYellowIcon() {
  return (
    <>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="36" height="36" rx="6" fill="#FFF2C4" />
        <rect
          width="24"
          height="24"
          transform="translate(6 6)"
          fill="#FFF2C4"
        />
        <path
          d="M18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30ZM19.3961 15.8818L17.8931 22.9395C17.7877 23.4492 17.9371 23.7393 18.3502 23.7393C18.6402 23.7393 19.0796 23.6338 19.3785 23.3701L19.2466 23.9941C18.816 24.5127 17.8668 24.8906 17.0494 24.8906C15.9947 24.8906 15.5464 24.2578 15.8365 22.9131L16.9439 17.71C17.0406 17.2705 16.9527 17.1123 16.5132 17.0068L15.8365 16.8838L15.9595 16.3125L19.3961 15.8818ZM18 14.25C17.1716 14.25 16.5 13.5784 16.5 12.75C16.5 11.9216 17.1716 11.25 18 11.25C18.8284 11.25 19.5 11.9216 19.5 12.75C19.5 13.5784 18.8284 14.25 18 14.25Z"
          fill="#D8A800"
        />
      </svg>
    </>
  );
}
